import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { IngresoAgendaVirtualComponent } from './ingreso-agenda/ingreso-agenda-virtual.component';
import { CancelarAgendaVirtualComponent } from './cancelar-agenda-virtual/cancelar-agenda-virtual.component';
import { SolicitarTurnoComponent } from './solicitar-turno/solicitar-turno.component';
import { AgendaVirtualComponent } from './agenda-virtual.component';

const routes: Routes = [
    { path: '', component: AgendaVirtualComponent,
        children: [
            { path: '', component: IngresoAgendaVirtualComponent },
            { path: 'cancelar-agenda-virtual', component: CancelarAgendaVirtualComponent },
            { path: 'solicitar-agenda-virtual', component: SolicitarTurnoComponent }
        ] }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class AgendaVirtualRouting { }
